import { Message } from 'element-ui'
import 'nprogress/nprogress.css' // Progress 进度条样式
import Cookies from 'js-cookie'
import NProgress from 'nprogress' // Progress 进度条
import { action } from 'sky-engine/api/index'
import router from 'sky-engine/router'
import { getStatus, getToken, setToken, setStatus } from 'sky-engine/utils/auth' // 验权

import { POC_MNG } from '@/api/apiModules'
import GlobalConst from '@/constant/globalConst'
import store from '@/store'

const isProdEnv = window.location.host.includes('ruijie.com.cn')

const whiteList = [
  '/login',
  '/register',
  'protocol',
  '/sysUpgrading',
  '/wspToolFeishuLogin',
  '/npsCollection',
  '/wspSidLogin'
] // 不重定向白名单
const configurationWizardEntryNames = [
  'configurationWizardWelcome',
  'configurationWizardDeployMode',
  'configurationWizard'
] // 配置向导入口地址名称
router.beforeEach((to, from, next) => {
  //释放用户的项目锁
  if (from.path === '/pocMng' && to.path !== '/pocMng') {
    action(POC_MNG, 'deleteLock')
      .then(response => {})
      .catch(e => {
        throw e
      })
  }

  var gotoActionUrl = window.localStorage.getItem('gotoActionUrl')

  if (to.path === '/gotoAction') {
    window.localStorage.setItem('gotoActionUrl', to.fullPath)
  }

  const hasTicket = window.location.href.includes('ticket')
  NProgress.start() // 开启Progress
  if (isProdEnv && hasTicket) {
    let ticket = window.location.href.split('ticket=')[1]
    ticket.includes('#/') && (ticket = ticket.slice(0, -2))
    Cookies.set('ticket', ticket)
    // OA登录成功时清理飞书残留的token标记，防止后续操作混乱
    const token = getToken()
    if (token && token.includes('|')) {
      setToken('')
    }
    if (Cookies.get('nextUrl')) {
      const nextUrl = Cookies.get('nextUrl')
      Cookies.remove('nextUrl')
      window.location.href = `${nextUrl}?ticket=${ticket}`
      return
    }

    setStatus(true)
    const oaUrl = `https://${window.location.host}/#${to.path}`
    window.location.href = oaUrl
  } else {
    if (getStatus() === 'true') {
      // 判断用户是否登录
      if (gotoActionUrl) {
        var toAction = gotoActionUrl.replace('gotoAction', 'toAction')
        window.localStorage.removeItem('gotoActionUrl')
        next({ path: toAction })
      }

      if (to.path === '/login') {
        next({ path: '/' })
        NProgress.done() // router在hash模式下 手动改变hash 重定向回来 不会触发afterEach 暂时hack方案 ps：history模式下无问题，可删除该行！
      } else {
        if (store.getters.name === '') {
          // 判断当前用户是否已拉取完user_info信息
          // 拉取user_info,同时拉取配置向导信息
          if (!store.getters.isSysUpgrading) {
            store.dispatch('InitLoading', true)
            var token = getToken()
            const isfeiShu = token !== undefined && token.includes('|first')
            // 优先级调整：URL参数 > 令牌标记 > Cookie > 本地认证
            // 避免过期的ticket Cookie导致飞书登录串掉
            const hasValidTicket = Cookies.get('ticket')
            const getInfoApi = hasValidTicket && !isfeiShu
              ? store.dispatch('GetOaUserInfo')  // OA登录：ticket优先，但要排除飞书场景
              : isfeiShu
              ? store.dispatch('GetFeiShuUserInfo')  // 飞书登录：|first标记最可信
              : store.dispatch('GetUserInfo')  // 本地认证
            Promise.all([getInfoApi])
              .then(results => {
                store.dispatch('InitLoading', false)
                const userInfo = results[0].data.content
                if (token != undefined) {
                  setToken(token.replace('|first', '|two'))
                }
                // let roleIdArr = [];
                // if (res.data.content.roleArr) {
                //   roleIdArr = res.data.content.roleArr.map(role => {
                //     return role.id;
                //   })
                // }
                // const roles = [roleIdArr]
                // const menu = res.data.content.menu //  可访问的菜单
                // 递归过滤路由表，根据是否为超级管理员来控制菜单(后续权限控制具体设计以后可删除)
                if (shouldRedirectToConfiguration(to, from, next)) {
                  return
                }
                const hasSuperPrivilege = userInfo.hasSuperPrivilege || false
                const approvalStatus = userInfo.approvalStatus
                const menu = userInfo.menuNameArr
                store.getters.baseInfo = userInfo
                store.dispatch('GenerateRoutes', { hasSuperPrivilege, menu, approvalStatus }).then(() => {
                  // 生成可访问的路由表
                  router.addRoutes(store.getters.addRouters)
                  // 判断是否认证过`
                  next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,replace: true so the navigation will not leave a
                })
              })
              .catch(e => {
                console.error(e)
                /**
                 * 此处可能是获取用户信息失败
                 * 或者或者配置向导信息失败
                 */
                store.dispatch('InitLoading', false)
                if (!store.getters.isSysUpgrading) {
                  // 认证失败时清理可能过期的认证Cookie，防止下次路由导航再次串掉
                  // 场景：OA ticket过期，下次尝试飞书登录时需要彻底清理旧ticket
                  Cookies.remove('ticket')
                  const token = getToken()
                  if (token && token.includes('|')) {
                    setToken('')  // 清理飞书token标记
                  }
                  store.dispatch('FedLogOut').then(() => {
                    Message.error('验证失败,请重新登录')
                    store.dispatch('LogOut').then(() => {})
                    next({ name: 'login' })
                    NProgress.done()
                  })
                }
              })
          } else {
            next()
          }
        } else {
          if (shouldRedirectToConfiguration(to, from, next)) {
            return
          }
          // 没有动态改变权限的需求可直接next() 删除下方权限判断 ,这边有bug,当动态：id 参数path 地址，判断出问题
          if (router.matcher.getCurPath(to.path)) {
            next()
          } else {
            next({
              path: '/login',
              query: {
                noGoBack: true
              }
            })
            NProgress.done() // router在hash模式下 手动改变hash 重定向回来 不会触发afterEach 暂时hack方案 ps：history模式下无问题，可删除该行！
          }
        }
      }
    } else {
      if (to.redirectedFrom !== undefined) {
        if (window.location.pathname.indexOf('/feishu/loginSuccess') === 0) {
          var search = window.location.search
          var code_before = search.replace('?code=', '')
          var code = code_before.replace('&state=STATE', '|first')
          // 飞书登录成功时，清理OA残留的ticket，防止下次路由串掉
          Cookies.remove('ticket')
          store.dispatch('loginByFeiShu', { code: code })
          // next()
          window.location = window.location.origin
        } else if (window.location.pathname.indexOf('/wsptool/feishu/loginSuccess') === 0) {
          search = window.location.search
          code_before = search.replace('?code=', '')
          code = code_before.replace('&state=STATE', '|first')
          var wspToolClientId = Cookies.get('wspToolClientId')
          // 飞书工具登录时也清理OA残留数据
          Cookies.remove('ticket')
          // 其他系统用wsp作为跳板登录，需要重新跳回原系统
          if (window.top !== window.self) {
            window.parent.location.href = GlobalConst.TRAIN_PLATFORM_URL + `/?ticket=${code}`
          }
          store.dispatch('wspToolByFeiShu', { code: code, wspToolClientId: wspToolClientId })
          // next()
          window.location = window.location.origin
        } else {
          next('/login')
        }
      } else {
        if ((isProdEnv && to.path === '/login') || whiteList.indexOf(to.path) !== -1) {
          // 在免登录白名单，直接进入
          next()
        } else {
          next('/login') // 否则全部重定向到登录页
          NProgress.done() // router在hash模式下 手动改变hash 重定向回来 不会触发afterEach 暂时hack方案 ps：history模式下无问题，可删除该行！
        }
      }
    }
  }
})

router.afterEach(to => {
  NProgress.done()
})

function shouldRedirectToConfiguration(to, from, next) {
  if (store.getters.configurationWizardVisible) {
    const index = configurationWizardEntryNames.indexOf(to.name)
    const name =
      configurationWizardEntryNames[
        store.getters.configurationWizardStep < 2 ? store.getters.configurationWizardStep : 2
      ]
    if (index >= 0 && name === to.name) {
      next()
    } else {
      /**
       * 登陆成功路由到dashbord
       * 配置信息show = true时
       * 走此流程，to.name = dashbord；
       *
       * 配置信息show = true时，
       * 手动输入切换路由/dashbord，通过程序跳转判断
       */
      let toName = configurationWizardEntryNames[0]
      if (to.name === 'serverProtocol') {
        toName = 'serverProtocol'
        next()
      } else {
        if (store.getters.configurationWizardStep > 0 && store.getters.configurationWizardStep < 2) {
          toName = configurationWizardEntryNames[store.getters.configurationWizardStep]
        } else if (store.getters.configurationWizardStep >= 2) {
          toName = configurationWizardEntryNames[2]
        }
        next({ name: toName })
      }

      /**
       * 配置向导欢迎页手动输入/dashbord
       * 通过程序重新跳回配置向导欢迎页导致NProgress不会关闭问题
       */
      if (toName === from.name) {
        NProgress.done()
      }
    }
    return true
  } else if (configurationWizardEntryNames.indexOf(to.name) >= 0) {
    /**
     * 配置信息show = false
     * 手动切换路由到配置向导相关路由，直接返回首页，不做其他处理
     */
    next({ path: '/', replace: true })
    if (from.name === 'dashboard') {
      NProgress.done()
    }
    return true
  }
  return false
}
